import { MutationTree } from 'vuex'
import { DocumentosReceberState } from './documentosReceberState';

const state: DocumentosReceberState = {
    isLoading: false,
    lista: []
};

const mutations: MutationTree<DocumentosReceberState> = {
    carregarDocumentosReceber(state) {
        state.isLoading = true
    },
    listaDocumentosReceber(state, payload) {
        state.isLoading = false
        state.lista = payload
    }
}

export default {
    namespaced: true,
    state,
    mutations
}